import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/web/app/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/web/app/layouts/default.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/app/web/app/layouts/public.vue").then(m => m.default || m))
}